export const price = (price: number) => {
  // INFO: without Math.round() -> +145.7 * 100 = 14569.999999999998
  return Math.round(price * 100);
};
